export default "__VITE_ASSET__DZvT3OoA__"